import React from 'react';
import { CartEditorProps } from './Cart.types';
import CartComponent from './Cart.component';
import { adaptCartEditorProps } from './Cart.adapter';
import './Cart.editor.css';

const CartEditor: React.FC<CartEditorProps> = (originalProps) => {
  // 어댑터를 통해 속성 변환
  const props = adaptCartEditorProps(originalProps);
  
  // 선택 상태에 따른 스타일 적용
  const editorStyle = {
    ...props.style,
    outline: props.isSelected ? '2px solid #007bff' : 'none',
    outlineOffset: '2px',
    minHeight: '200px'
  };
  
  return (
    <div 
      className={`component-editor-wrapper ${props.isSelected ? 'selected' : ''}`}
      data-component-id={props.id}
      data-component-type="Cart"
    >
      <CartComponent
        {...props}
        style={editorStyle}
        isEditor={true}
      />
      
      {/* 에디터 모드에서만 표시되는 컴포넌트 크기 조절 핸들 */}
      {props.isSelected && (
        <div className="component-resize-handles">
          <div className="resize-handle resize-handle-top" />
          <div className="resize-handle resize-handle-right" />
          <div className="resize-handle resize-handle-bottom" />
          <div className="resize-handle resize-handle-left" />
          <div className="resize-handle resize-handle-top-left" />
          <div className="resize-handle resize-handle-top-right" />
          <div className="resize-handle resize-handle-bottom-right" />
          <div className="resize-handle resize-handle-bottom-left" />
        </div>
      )}
    </div>
  );
};

export default CartEditor; 